<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate [formGroup]="feeTempletForm">
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm" >
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body">

                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class=" d-flex align-items-center pl-3">
                                                <img alt="Logo" src="../../assets/img/ExamMaster.png"
                                                    class="mh-45px pb-2">
                                                <p class="mb-1">
                                                    <span class="main-content-label"><b>{{FeesTemplate}}</b></span><br>
                                                    <span class="text-muted card-sub-title mb-0"> List Of Fees
                                                        Templates</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-md-2" *ngIf="ExamListBtn" [formGroup]="FeeTemplateSearch">
                                            <mat-form-field appearance="outline" class="example-full-width ser">
                                                <mat-label>Search
                                                </mat-label> <input class="color" matInput placeholder="Search"
                                                    (keyup)="keypress()" formControlName="SearchString">
                                                <mat-icon matSuffix>search</mat-icon>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-2" *ngIf="AdmListBtn" [formGroup]="FeeTemplateSearch">
                                            <mat-form-field appearance="outline" class="example-full-width ser">
                                                <mat-label>Search
                                                </mat-label> <input class="color" matInput placeholder="Search"
                                                    (keyup)="keypress()" formControlName="SearchString">
                                                <mat-icon matSuffix>search</mat-icon>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-2" *ngIf="TclcListBtn" [formGroup]="FeeTemplateSearch">
                                            <mat-form-field appearance="outline" class="example-full-width ser">
                                                <mat-label>Search
                                                </mat-label> <input class="color" matInput placeholder="Search"
                                                    (keyup)="keypress()" formControlName="SearchString">
                                                <mat-icon matSuffix>search</mat-icon>
                                            </mat-form-field>
                                        </div>
                                        <div  class="col-md-6 prpl">
                                            <!-- <button *ngIf="ExamListBtn" style="width:14vh;" id="addBtn" type="button"
                                                class="btn btn-primary btn-icon-text mr-3 mt-1"
                                                (click)="ExamList()">
                                                <span style="display: flex; align-items: center;">
                                                   Exam List
                                                </span>
                                            </button> -->

                                            <mat-radio-group formControlName="radio" class="example-full-width marginnn">
                                            <div class="row">
                                              <div class="col-sm-3 ml mt-2">
                                                <mat-radio-button value='AF' (click)="AdmList()">Admission Templates</mat-radio-button>
                                              </div>
                                              <div class="col-sm-3 ml mt-2" style="margin-left: -1rem;">
                                                <mat-radio-button value='EF' (click)="ExamList()"> Exam Templates</mat-radio-button>
                                                
                                              </div>
                                              <div class="col-sm-4 mt-2" style="margin-left: -2rem;">
                                                <!-- <mat-radio-button value='TCLC' (click)="TclcList()"> TC/LC Templates</mat-radio-button> -->
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label> TC/LC Templates </mat-label>
                                                            <mat-select formControlName="tclc" #select533 class="colorblack">
                                                                <mat-select-filter *ngIf="select533.focused"
                                                                    [placeholder]="'Filter'" [displayMember]="'CdCode'"
                                                                    [array]="TCList"
                                                                    (filteredReturn)="filterTCList =$event"></mat-select-filter>
                                                                <mat-option *ngFor="let item of filterTCList"
                                                                    [value]="item.CdCode" (click)="TclcList(item.CdCode)">
                                                                    {{item.CdDesc}}
                                                                </mat-option>
                                                            </mat-select>
    
                                                        </mat-form-field>
    
    
                                                    </div>
                                                </div>
                                              </div>
                                              <div class="col-md-2 prpl ml2">
                                                <button id="addBtn" type="button"  *ngIf="ExamListBtn"
                                                    class="btn btn-primary btn-icon-text  mt-1"
                                                    (click)="addnewrecord()">
                                                    <span style="display: flex; align-items: center;">
                                                        <img width="20vh" src="../../assets/img/plus.gif"
                                                            style="margin-right: 5px;">
                                                       New
                                                    </span>
                                                </button>
                                                <button id="addBtn" type="button"  *ngIf="TclcListBtn"
                                                    class="btn btn-primary btn-icon-text  mt-1"
                                                    (click)="addnewrecord()">
                                                    <span style="display: flex; align-items: center;">
                                                        <img width="20vh" src="../../assets/img/plus.gif"
                                                            style="margin-right: 5px;">
                                                            New
                                                    </span>
                                                </button>
                                                <button id="addBtn" type="button" *ngIf="AdmListBtn"
                                                class="btn btn-primary btn-icon-text  mt-1"
                                                (click)="addnewrecord()">
                                                <span style="display: flex; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/plus.gif"
                                                        style="margin-right: 5px;">
                                                        New
                                                </span>
                                            </button>
                                            </div>
                                             
                                            </div>
                                            
                                          </mat-radio-group>
                                          
                                        </div>

                                        <!-- <div *ngIf="AdmListBtn" class="col-md-1 prpl">
                                            <button   style="width:19vh;" id="addBtn" type="button"
                                                class="btn btn-primary btn-icon-text mr-3 mt-1"
                                                (click)="AdmList()">
                                                <span style="display: flex; align-items: center;">
                                                   
                                                   Admission List
                                                </span>
                                            </button>
                                        </div> -->
                                        
                                        <!-- <div *ngIf="AdmListBtn" class="col-md-1 prpl ml2">
                                            <button id="addBtn" type="button"
                                                class="btn btn-primary btn-icon-text  mt-1"
                                                (click)="addnewrecord()">
                                                <span style="display: flex; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/plus.gif"
                                                        style="margin-right: 5px;">
                                                    {{ 'header.college-data.titleList.AddNewRecord' | translate }}
                                                </span>
                                            </button>
                                        </div> -->
                                    </div>
                                    <hr>

                                    <div *ngIf="AdmissionFee" class="table-responsive table-container tab mt-1">
                                        <table appShortTable id="datatable" class="table table-bordered text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th class="f600">
                                                        Template Code
                                                    </th>
                                                    <th class="f600">
                                                        Template Name
                                                    </th>
                                                    <th class="f600">
                                                        Exam
                                                    </th>
                                                    <th class="f600">
                                                        Student Type
                                                    </th>
                                                    <th class="f600">
                                                        Student Status
                                                    </th>
                                                    <th class="f600">
                                                        Cast
                                                    </th>

                                                    <th width="10%" class="f600 text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <tr *ngFor="let item of FeeTempletList;">
                                                    <td>
                                                        {{item.TemplateCode}}
                                                    </td>
                                                    <td>
                                                        {{item.TemplateName}}
                                                    </td>
                                                    <td>
                                                        {{item.EmName}}
                                                    </td>
                                                    <td>
                                                        {{item.StudentTypeDesc}}
                                                    </td>
                                                    <td>
                                                        {{item.StudentStatusDesc}}
                                                    </td>
                                                    <td>
                                                        {{item.CasteDesc}}
                                                    </td>

                                                    <td class="text-center"> <a class="floating mr-2 pr-3" title="Edit"
                                                            (click)="editData(item)"> <i class="fa fa-edit "></i> </a>
                                                        <a class=" ml-2 floating" title="Delete"
                                                            (click)="deleteData(item)"> <i class="fas fa-trash"></i>
                                                        </a> </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div *ngIf="ExamFee" class="table-responsive table-container tab mt-1">
                                        <table appShortTable id="datatable" class="table table-bordered text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th class="f600">
                                                        Template Code
                                                    </th>
                                                    <th class="f600">
                                                        Template Name
                                                    </th>
                                                    <th class="f600">
                                                        Exam
                                                    </th>
                                                    <th class="f600">
                                                        Student Type
                                                    </th>
                                                    <th class="f600">
                                                        Student Status
                                                    </th>
                                                    <th class="f600">
                                                        Cast
                                                    </th>

                                                    <th width="10%" class="f600 text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <tr *ngFor="let item of FeeTempletList;">
                                                    <td>
                                                        {{item.TemplateCode}}
                                                    </td>
                                                    <td>
                                                        {{item.TemplateName}}
                                                    </td>
                                                    <td>
                                                        {{item.EmName}}
                                                    </td>
                                                    <td>
                                                        {{item.StudentTypeDesc}}
                                                    </td>
                                                    <td>
                                                        {{item.StudentStatusDesc}}
                                                    </td>
                                                    <td>
                                                        {{item.CasteDesc}}
                                                    </td>

                                                    <td class="text-center"> <a class="floating mr-2 pr-3" title="Edit"
                                                            (click)="editData(item)"> <i class="fa fa-edit "></i> </a>
                                                        <a class=" ml-2 floating" title="Delete"
                                                            (click)="deleteData(item)"> <i class="fas fa-trash"></i>
                                                        </a> </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div *ngIf="TclcFee" class="table-responsive table-container tab mt-1">
                                        <table appShortTable id="datatable" class="table table-bordered text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th class="f600">
                                                        Template Code
                                                    </th>
                                                    <th class="f600">
                                                        Template Name
                                                    </th>
                                                    <th class="f600">
                                                        Exam
                                                    </th>
                                                    <th class="f600">
                                                        Student Type
                                                    </th>
                                                    <th class="f600">
                                                        Student Status
                                                    </th>
                                                    <th class="f600">
                                                        Cast
                                                    </th>

                                                    <th width="10%" class="f600 text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <tr *ngFor="let item of FeeTempletList;">
                                                    <td>
                                                        {{item.TemplateCode}}
                                                    </td>
                                                    <td>
                                                        {{item.TemplateName}}
                                                    </td>
                                                    <td>
                                                        {{item.EmName}}
                                                    </td>
                                                    <td>
                                                        {{item.StudentTypeDesc}}
                                                    </td>
                                                    <td>
                                                        {{item.StudentStatusDesc}}
                                                    </td>
                                                    <td>
                                                        {{item.CasteDesc}}
                                                    </td>

                                                    <td class="text-center"> <a class="floating mr-2 pr-3" title="Edit"
                                                            (click)="editData(item)"> <i class="fa fa-edit "></i> </a>
                                                        <a class=" ml-2 floating" title="Delete"
                                                            (click)="deleteData(item)"> <i class="fas fa-trash"></i>
                                                        </a> </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <mat-paginator *ngIf="AdmissionFee" [length]="totalItems" [pageSize]="pageSize"
                                        [pageSizeOptions]="pageSizeOptions"
                                        (page)="onPageChange($event,'AF')"></mat-paginator>
                                    <mat-paginator *ngIf="ExamFee" [length]="totalItems" [pageSize]="pageSize"
                                        [pageSizeOptions]="pageSizeOptions"
                                        (page)="onPageChange($event,'EF')"></mat-paginator>
                                    <mat-paginator *ngIf="TC" [length]="totalItems" [pageSize]="pageSize"
                                        [pageSizeOptions]="pageSizeOptions"
                                        (page)="onPageChange($event,'TC')"></mat-paginator>
                                    <mat-paginator *ngIf="LC" [length]="totalItems" [pageSize]="pageSize"
                                        [pageSizeOptions]="pageSizeOptions"
                                        (page)="onPageChange($event,'LC')"></mat-paginator>
                                    <mat-paginator *ngIf="MC" [length]="totalItems" [pageSize]="pageSize"
                                        [pageSizeOptions]="pageSizeOptions"
                                        (page)="onPageChange($event,'MC')"></mat-paginator>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </form>
</body>